import { render, staticRenderFns } from "./newsPageView.vue?vue&type=template&id=1935f742&"
import script from "./newsPageView.vue?vue&type=script&lang=js&"
export * from "./newsPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports